import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { Field } from "../../components/neu/Field";
import { DateInput } from "../../components/neu/DateInput";
import { CertificateUpload } from "./CertificateUpload";

const z = (n) => String(n).padStart(2, "0");
const fmt = (d) => `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
const localToday = () => fmt(new Date());
const addDays = (iso, n) => {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + n);
  return fmt(d);
};

// حقول نموذج الإجازة التقليدية (سنوية / مرضية / طارئة / بدون راتب)
// مستخرجة من LeaveForm للحفاظ على قاعدة 100 سطر لكل ملف.
export const LeaveFormFields = ({ balance, form, setForm, onSubmit, busy }) => {
  const { t } = useTranslation();
  const needCertificate = form.leave_type === "sick" && balance.sick_requires_certificate;
  const set = (k, v) => setForm({ ...form, [k]: v });
  const today = localToday();
  const exempt = ["sick", "emergency"].includes(form.leave_type);
  const minStart = exempt ? today : addDays(today, balance.min_notice_days || 0);

  const setStart = (v) => {
    if (v && v < minStart) { toast.error(t("leaves.startTooSoon", { date: minStart })); v = minStart; }
    const end = form.end_date && v && form.end_date < v ? v : form.end_date;
    setForm({ ...form, start_date: v, end_date: end });
  };
  const setEnd = (v) => {
    const floor = form.start_date || minStart;
    if (v && v < floor) { toast.error(t("leaves.endBeforeStart")); v = floor; }
    set("end_date", v);
  };

  return (
    <form className="mt-4 grid gap-4 sm:grid-cols-2" onSubmit={onSubmit} data-testid="leave-form">
      <DateInput label={t("leaves.from")} testId="leave-start" value={form.start_date}
                 min={minStart} onChange={setStart} required />
      <DateInput label={t("leaves.to")} testId="leave-end" value={form.end_date}
                 min={form.start_date || minStart} onChange={setEnd} required />
      <p className="text-xs text-muted-foreground sm:col-span-2">
        {t("leaves.hint", { count: balance.min_notice_days })}
      </p>
      {needCertificate ? (
        <div className="sm:col-span-2">
          <CertificateUpload value={form.certificate_url}
                             onChange={(url) => set("certificate_url", url)} />
        </div>
      ) : null}
      <div className="sm:col-span-2">
        <Field label={t("leaves.reason")} testId="leave-reason" value={form.reason}
               onChange={(v) => set("reason", v)} />
      </div>
      <NeuButton variant="primary" type="submit" data-testid="leave-submit"
                 disabled={busy} className="w-full py-4 text-base sm:col-span-2">
        {t("leaves.submit")}
      </NeuButton>
    </form>
  );
};
